import PageLayout from '@/components/page/page-layout'

const Live = () => import('@/views/live')

const router = {
  path: '/live',
  component: PageLayout,
  name: 'Live',
  icon: 'none',
  children: [
    {
      path: '/',
      name: '画面直播',
      component: Live,
      meta: {
        hideBreadcrumb: true,
        hideSider: true,
        title: '画面直播'
      }
    }
  ]
}

export default router
